var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm.isAuthenticated
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "elevation-2",
              attrs: {
                "hide-overlay": "",
                app: "",
                dark: "",
                src: _vm.backgroundMenu,
                color: _vm.sideBarColor,
                clipped: ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "pa-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "px-2" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      block: "",
                                      "data-cy": "logout",
                                      loading: _vm.load_logout,
                                      color: _vm.colorBotaoSair
                                    },
                                    on: { click: _vm.logout }
                                  },
                                  [
                                    _vm._v(" sair "),
                                    _c("v-icon", { staticClass: "ml-2" }, [
                                      _vm._v("mdi-logout")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-card-text",
                              {
                                staticClass:
                                  "grey--text text--darken-2 text-center",
                                style: _vm.sidebarTextStyle
                              },
                              [_vm._v(" Versão: " + _vm._s(_vm.version) + " ")]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3836615503
              ),
              model: {
                value: _vm.showDrawer,
                callback: function($$v) {
                  _vm.showDrawer = $$v
                },
                expression: "showDrawer"
              }
            },
            [
              _c(
                "v-list",
                { attrs: { dense: "", "data-cy": "drawerList" } },
                [
                  _c(
                    "v-list-item",
                    {
                      attrs: { "two-line": "" },
                      model: {
                        value: _vm.isAuthenticated,
                        callback: function($$v) {
                          _vm.isAuthenticated = $$v
                        },
                        expression: "isAuthenticated"
                      }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        {
                          class: _vm.computedGetPartner
                            ? "grey--text text--darken-2"
                            : "",
                          style: _vm.sidebarTextStyle
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("mdi-account-circle")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass: "title",
                              class: _vm.computedGetPartner
                                ? "grey--text text--darken-2"
                                : "",
                              style: _vm.sidebarTextStyle
                            },
                            [_vm._v(_vm._s(_vm.computedGetUserName))]
                          ),
                          _c(
                            "v-list-item-subtitle",
                            {
                              class: _vm.computedGetPartner
                                ? "grey--text text--darken-2"
                                : "",
                              style: _vm.sidebarTextStyle
                            },
                            [_vm._v(_vm._s(_vm.computedGetUserLogin))]
                          ),
                          _vm.usuarioAgrupador
                            ? _c("v-list-item-subtitle", [
                                _vm._v(
                                  "Agrupador: " + _vm._s(_vm.usuarioAgrupador)
                                )
                              ])
                            : _vm._e(),
                          _vm.superUsuario
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "justify-center align-center py-2 px-0",
                                  staticStyle: { display: "grid", gap: "8px" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "left"
                                      },
                                      attrs: {
                                        widht: "100%",
                                        "x-small": "",
                                        color: "primary"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ma-1 white--text",
                                          attrs: { "x-small": "" }
                                        },
                                        [_vm._v("mdi-checkbox-marked-circle")]
                                      ),
                                      _vm._v(" Super Usuário ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on, attrs }) {
                                              return [
                                                _vm.apresentanteNotifica
                                                  ? _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticStyle: {
                                                              display: "flex",
                                                              "justify-content":
                                                                "center"
                                                            },
                                                            attrs: {
                                                              widht: "100%",
                                                              "x-small": "",
                                                              color: "primary"
                                                            }
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "ma-1 white--text",
                                                            attrs: {
                                                              "x-small": ""
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-checkbox-marked-circle"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" Notifica ")
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        173191758
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              `Apresentante ${_vm.computedGetApresentante} habilitado na Notifica!`
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "grey lighten-2" }),
                  _vm.usuarioRecuperi
                    ? [
                        _vm._l(_vm.menusRecuperi, function(item) {
                          return [
                            item.childs &&
                            _vm.isShowItem(item, _vm.isAuthenticated)
                              ? _c(
                                  "v-list-group",
                                  {
                                    key: item.text,
                                    style: _vm.sidebarTextStyle,
                                    attrs: {
                                      "data-cy": _vm.getValorDataCypress(item),
                                      color: "white"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "appendIcon",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-icon",
                                                { style: _vm.sidebarTextStyle },
                                                [_vm._v(" mdi-chevron-down ")]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "activator",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-list-item-icon",
                                                { style: _vm.sidebarTextStyle },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        height: "24px"
                                                      },
                                                      attrs: {
                                                        elevation: "0",
                                                        fab: "",
                                                        text: "",
                                                        small: "",
                                                        loading: _vm.loadingIcon
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          style:
                                                            _vm.sidebarTextStyle
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.icon)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-title",
                                                { style: _vm.sidebarTextStyle },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.text) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._l(item.childs, function(child) {
                                      return [
                                        _vm.isShowItem(
                                          child,
                                          _vm.isAuthenticated
                                        )
                                          ? _c(
                                              "v-list-item",
                                              {
                                                key: child.text,
                                                style: _vm.sidebarTextStyle,
                                                attrs: {
                                                  to: child.path,
                                                  "data-cy": _vm.getValorDataCypress(
                                                    child
                                                  )
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticStyle: {
                                                      height: "24px"
                                                    },
                                                    attrs: {
                                                      elevation: "0",
                                                      fab: "",
                                                      text: "",
                                                      small: "",
                                                      loading: _vm.loadingIcon
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        style:
                                                          _vm.sidebarTextStyle
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(child.icon)
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    style: _vm.sidebarTextStyle
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(child.text) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm.isShowItem(item, _vm.isAuthenticated)
                              ? _c(
                                  "v-list-item",
                                  {
                                    key: item.text,
                                    style: _vm.sidebarTextStyle,
                                    attrs: {
                                      to: item.path,
                                      "data-cy": _vm.getValorDataCypress(item)
                                    }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          elevation: "0",
                                          fab: "",
                                          text: "",
                                          small: "",
                                          loading: _vm.loadingIcon
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { style: _vm.sidebarTextStyle },
                                          [_vm._v(_vm._s(item.icon))]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-title",
                                      { style: _vm.sidebarTextStyle },
                                      [_vm._v(_vm._s(item.text))]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        })
                      ]
                    : _vm._e(),
                  _vm.usuarioPartner
                    ? [
                        _vm._l(_vm.menusPartner, function(item) {
                          return [
                            item.childs &&
                            _vm.isShowItem(item, _vm.isAuthenticated)
                              ? _c(
                                  "v-list-group",
                                  {
                                    key: item.text,
                                    attrs: {
                                      "data-cy": _vm.getValorDataCypress(item),
                                      color: "white",
                                      "append-icon": "mdi-chevron-down",
                                      "append-icon-cb": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "appendIcon",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "grey--text text--darken-2"
                                                },
                                                [_vm._v(" mdi-chevron-down ")]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "activator",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-list-item-icon",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "grey--text text--darken-2",
                                                      staticStyle: {
                                                        height: "24px"
                                                      },
                                                      attrs: {
                                                        elevation: "0",
                                                        fab: "",
                                                        text: "",
                                                        small: "",
                                                        loading: _vm.loadingIcon
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          _vm._s(item.icon)
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass:
                                                    "grey--text text--darken-2"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.text) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._l(item.childs, function(child) {
                                      return [
                                        _vm.isShowItem(
                                          child,
                                          _vm.isAuthenticated
                                        )
                                          ? _c(
                                              "v-list-item",
                                              {
                                                key: child.text,
                                                staticClass:
                                                  "grey--text text--darken-2",
                                                attrs: {
                                                  to: child.path,
                                                  "data-cy": _vm.getValorDataCypress(
                                                    child
                                                  )
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticStyle: {
                                                      height: "24px"
                                                    },
                                                    attrs: {
                                                      elevation: "0",
                                                      fab: "",
                                                      text: "",
                                                      small: "",
                                                      loading: _vm.loadingIcon
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(_vm._s(child.icon))
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(child.text) +
                                                      " "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm.isShowItem(item, _vm.isAuthenticated)
                              ? _c(
                                  "v-list-item",
                                  {
                                    key: item.text,
                                    staticClass: "grey--text text--darken-2",
                                    attrs: {
                                      to: item.path,
                                      "data-cy": _vm.getValorDataCypress(item),
                                      "active-class": "grey lighten-5"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          elevation: "0",
                                          fab: "",
                                          text: "",
                                          small: "",
                                          loading: _vm.loadingIcon,
                                          color: "grey darken-2"
                                        }
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v(_vm._s(item.icon))
                                        ])
                                      ],
                                      1
                                    ),
                                    _c("v-list-item-title", [
                                      _vm._v(_vm._s(item.text))
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        })
                      ]
                    : _vm._e(),
                  [
                    _c(
                      "v-list-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.$vuetify.breakpoint.xs && !_vm.isSocialUser,
                            expression:
                              "$vuetify.breakpoint.xs && !isSocialUser"
                          }
                        ],
                        key: "password",
                        on: { click: _vm.minhaConta }
                      },
                      [
                        _c(
                          "v-list-item-action",
                          [_c("v-icon", [_vm._v("mdi-account")])],
                          1
                        ),
                        _c(
                          "v-list-item-content",
                          [_c("v-list-item-title", [_vm._v("Minha Conta")])],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-app-bar",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isAuthenticated,
              expression: "isAuthenticated"
            }
          ],
          class:
            _vm.$vuetify.breakpoint.lgAndUp && !_vm.computedGetPartner
              ? ""
              : "mobile-toolbar",
          attrs: {
            "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
            app: "",
            color: _vm.colorBar,
            dark: "",
            dense: !_vm.computedGetPartner,
            "data-cy": "homeToolbar"
          }
        },
        [
          _c("v-app-bar-nav-icon", {
            class: _vm.computedGetPartner ? "grey--text text--darken-2" : "",
            style: _vm.headerTextStyle,
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.changeDrawer.apply(null, arguments)
              }
            }
          }),
          _c(
            "router-link",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
              },
              attrs: { to: "" }
            },
            [
              _vm.usuarioRecuperi
                ? _c("v-img", {
                    attrs: {
                      "data-cy": "logoHeader",
                      src: _vm.logo,
                      alt: "logo-recuperi",
                      width: _vm.wlLogoWidth
                    }
                  })
                : _vm._e(),
              _vm.usuarioPartner && _vm.$vuetify.breakpoint.lgAndUp
                ? _c("v-img", {
                    staticClass: "mr-2",
                    attrs: {
                      "data-cy": "logoHeader",
                      src: _vm.logoRecuperiAlt,
                      alt: "logo-recuperi-alt",
                      width: "120px"
                    }
                  })
                : _vm._e(),
              _vm.usuarioPartner
                ? _c("v-img", {
                    attrs: { src: _vm.logoBvs, alt: "logo-bvs", width: "210px" }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm.usuarioRecuperi && _vm.$vuetify.breakpoint.lgAndUp
            ? _c("v-switch", {
                staticClass: "ml-2",
                attrs: {
                  label: "Beta",
                  color: "red",
                  "data-cy": "switchBeta",
                  "hide-details": ""
                },
                on: {
                  click: function($event) {
                    return _vm.setVersaoBeta()
                  }
                },
                model: {
                  value: _vm.versaoBeta,
                  callback: function($$v) {
                    _vm.versaoBeta = $$v
                  },
                  expression: "versaoBeta"
                }
              })
            : _vm._e(),
          _vm.avisoHomologacao
            ? _c(
                "v-btn",
                {
                  staticClass: "success ml-4 mt-3 font-weight-black",
                  attrs: { small: "" }
                },
                [
                  _c("v-icon", { attrs: { "x-small": "" } }, [
                    _vm._v("mdi-information-outline")
                  ]),
                  _vm._v("homologação ")
                ],
                1
              )
            : _vm._e(),
          _vm.$vuetify.breakpoint.lgAndUp ? _c("v-spacer") : _vm._e(),
          _vm.userProfile && _vm.superUsuario && _vm.$vuetify.breakpoint.lgAndUp
            ? _c(
                "div",
                {
                  staticClass: "title-apresentante cursor-pointer",
                  attrs: { "data-cy": "alterar-apresentante" },
                  on: { click: _vm.alterarApresentante }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.userProfile.cd_apresentante) +
                      " - " +
                      _vm._s(_vm.userProfile.nm_apresentante) +
                      " "
                  ),
                  _c("div", { staticClass: "title-apresentante-cnpj" }, [
                    _vm._v(
                      " " +
                        _vm._s(this.formatCnpj(_vm.userProfile.nu_cnpj)) +
                        " "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm.userProfile &&
          !_vm.superUsuario &&
          _vm.$vuetify.breakpoint.lgAndUp
            ? _c(
                "div",
                {
                  staticClass: "title-apresentante cursor-pointer",
                  class: _vm.computedGetPartner
                    ? "grey--text text--darken-2"
                    : "",
                  style: _vm.headerTextStyle
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.userProfile.cd_apresentante) +
                      " - " +
                      _vm._s(_vm.userProfile.nm_apresentante) +
                      " "
                  ),
                  _c("div", { staticClass: "title-apresentante-cnpj" }, [
                    _vm._v(
                      " " +
                        _vm._s(this.formatCnpj(_vm.userProfile.nu_cnpj)) +
                        " "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm.$vuetify.breakpoint.lgAndUp ? _c("v-spacer") : _vm._e(),
          _vm.$vuetify.breakpoint.lgAndUp
            ? _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "ma-2",
                                        attrs: {
                                          color: _vm.wlHeaderBtnColor,
                                          "x-small": "",
                                          fab: "",
                                          outlined:
                                            _vm.computedGetPartner ||
                                            _vm.wlBtnOutlined
                                        }
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", {}, [_vm._v("mdi-bell-badge")])
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1057234269
                      )
                    },
                    [
                      _c(
                        "v-list",
                        {
                          class: {
                            "grey lighten-4":
                              _vm.carregandoNotificacoes &&
                              _vm.itemsNotification.length > 0
                          },
                          staticStyle: { "overflow-y": "auto" },
                          attrs: { "max-width": "400px", "max-height": "500px" }
                        },
                        [
                          _vm.itemsNotification.length === 0 &&
                          !_vm.carregandoNotificacoes
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass: "ma-2 text-center grey--text"
                                    },
                                    [_vm._v(" Nenhuma divulgação disponível ")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.carregandoNotificacoes
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "ma-2 text-center" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "mr-2",
                                        attrs: { indeterminate: "", size: "20" }
                                      }),
                                      _vm._v(" Carregando... ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._l(_vm.itemsNotification, function(item, index) {
                            return _c(
                              "v-list-item",
                              {
                                key: index,
                                class: {
                                  "grey--text text--lighten-1":
                                    _vm.carregandoNotificacoes
                                },
                                attrs: { disabled: _vm.carregandoNotificacoes }
                              },
                              [
                                _c(
                                  "v-list-item-content",
                                  {
                                    staticClass: "ma-2",
                                    class: {
                                      "grey--text text--lighten-1":
                                        _vm.carregandoNotificacoes
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass: "font-weight-bold",
                                        class: {
                                          "grey--text text--lighten-1":
                                            _vm.carregandoNotificacoes
                                        }
                                      },
                                      [_vm._v(" " + _vm._s(item.assunto) + " ")]
                                    ),
                                    item.data_envio
                                      ? _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass: "caption",
                                            class: _vm.carregandoNotificacoes
                                              ? "grey--text text--lighten-2"
                                              : "grey--text"
                                          },
                                          [
                                            _vm._v(
                                              " Publicado em: " +
                                                _vm._s(
                                                  _vm.formatarData(
                                                    item.data_envio
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c("v-dialog", {
                                  attrs: {
                                    transition: "dialog-top-transition",
                                    "max-width": "800"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    class: {
                                                      "grey--text text--lighten-1":
                                                        _vm.carregandoNotificacoes
                                                    },
                                                    attrs: {
                                                      small: "",
                                                      elevation: "0",
                                                      disabled:
                                                        _vm.carregandoNotificacoes
                                                    }
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-chevron-right")
                                                ]),
                                                _vm._v(" Ver detalhes ")
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "default",
                                        fn: function(dialog) {
                                          return [
                                            _c(
                                              "v-card",
                                              [
                                                _c(
                                                  "v-toolbar",
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      dark: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card-title",
                                                      {
                                                        staticClass:
                                                          "font-weight-black"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.assunto)
                                                        )
                                                      ]
                                                    ),
                                                    _c("v-spacer"),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: { icon: "" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            dialog.value = false
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("mdi-close")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                item.imagem_url
                                                  ? _c(
                                                      "v-card-text",
                                                      {
                                                        staticClass:
                                                          "text-center pa-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "position-relative d-inline-block"
                                                          },
                                                          [
                                                            _c("v-img", {
                                                              staticClass:
                                                                "mx-auto rounded cursor-pointer",
                                                              attrs: {
                                                                src:
                                                                  item.imagem_url,
                                                                "max-width":
                                                                  "700",
                                                                "max-height":
                                                                  "500",
                                                                contain: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.expandirImagem(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mt-2 caption grey--text"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Clique na imagem para expandir "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.imagem_url
                                                  ? _c("v-divider")
                                                  : _vm._e(),
                                                item.data_envio
                                                  ? _c(
                                                      "v-card-text",
                                                      { staticClass: "pb-2" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Data de envio:"
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.formatarData(
                                                                item.data_envio
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                item.user
                                                  ? _c(
                                                      "v-card-text",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v("Enviado por:")
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.user.nm_user
                                                            ) +
                                                            " (" +
                                                            _vm._s(
                                                              item.user.ds_email
                                                            ) +
                                                            ") "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-card-actions",
                                                  {
                                                    staticClass: "justify-end"
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: { text: "" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            dialog.value = false
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("fechar")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          }),
                          _c("v-divider"),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-2" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "px-2",
                                  attrs: {
                                    "no-gutters": "",
                                    align: "center",
                                    justify: "space-between"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "px-2",
                                          attrs: {
                                            small: "",
                                            outlined: "",
                                            color: "primary",
                                            disabled:
                                              _vm.paginaAtualNotificacoes <=
                                                1 || _vm.carregandoNotificacoes
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.carregarPaginaAnterior.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-chevron-left")]
                                          ),
                                          _vm._v(" Anterior ")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("v-col", { staticClass: "text-center" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "caption font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          " Página " +
                                            _vm._s(
                                              _vm.paginaAtualNotificacoes
                                            ) +
                                            " de " +
                                            _vm._s(
                                              _vm.totalPaginasNotificacoes
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "caption grey--text" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.totalItensNotificacoes) +
                                            " divulgações "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "px-2",
                                          attrs: {
                                            small: "",
                                            outlined: "",
                                            color: "primary",
                                            disabled:
                                              _vm.paginaAtualNotificacoes >=
                                                _vm.totalPaginasNotificacoes ||
                                              _vm.carregandoNotificacoes
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.carregarProximaPagina.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(" Próxima "),
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-chevron-right")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "90vw",
                "max-height": "90vh",
                "overlay-opacity": "0.9"
              },
              model: {
                value: _vm.dialogImagemExpandida,
                callback: function($$v) {
                  _vm.dialogImagemExpandida = $$v
                },
                expression: "dialogImagemExpandida"
              }
            },
            [
              _vm.imagemSelecionada
                ? _c(
                    "v-card",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { color: "primary", dark: "" } },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(_vm._s(_vm.imagemSelecionada.assunto))
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.fecharImagemExpandida }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticClass: "pa-4" },
                        [
                          _c("v-img", {
                            staticClass: "mx-auto",
                            staticStyle: {
                              "max-height": "70vh",
                              margin: "auto"
                            },
                            attrs: {
                              src: _vm.imagemSelecionada.imagem_url,
                              contain: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        { staticClass: "justify-center pa-2" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: { click: _vm.fecharImagemExpandida }
                            },
                            [_vm._v(" Fechar ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.baixarImagem(_vm.imagemSelecionada)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-download")
                              ]),
                              _vm._v(" Baixar Imagem ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.$vuetify.breakpoint.lgAndUp
            ? _c(
                "div",
                [
                  _vm.isSuperUser
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            color: _vm.wlHeaderBtnColor,
                            small: "",
                            "data-cy": "btnRelatorios"
                          },
                          on: {
                            click: function($event) {
                              _vm.dialogModalRelatorios = true
                            }
                          }
                        },
                        [
                          _vm._v(" Relatórios "),
                          _c(
                            "v-icon",
                            { staticClass: "mx-2", attrs: { small: "" } },
                            [_vm._v("mdi-file-chart-outline")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.$vuetify.breakpoint.lgAndUp && !_vm.isSocialUser
            ? _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: {
                        color: _vm.wlHeaderBtnColor,
                        small: "",
                        outlined: _vm.computedGetPartner || _vm.wlBtnOutlined
                      },
                      on: { click: _vm.minhaConta }
                    },
                    [
                      _vm._v(" Minha Conta "),
                      _c(
                        "v-icon",
                        { staticClass: "mx-2", attrs: { small: "" } },
                        [_vm._v("mdi-account")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$vuetify.breakpoint.lgAndUp && _vm.isSocialUser
            ? _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { color: _vm.wlHeaderBtnColor, small: "" },
                      on: { click: _vm.socialUserAlterarEmpresa }
                    },
                    [
                      _vm._v(" Alterar Empresa "),
                      _c(
                        "v-icon",
                        { staticClass: "mx-2", attrs: { small: "" } },
                        [_vm._v("mdi-swap-horizontal")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {},
            [
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: {
                    loading: _vm.load_logout,
                    small: "",
                    color: _vm.wlHeaderBtnColor,
                    "data-cy": "logoutToolBar",
                    rounded: _vm.$vuetify.breakpoint.smAndDown,
                    outlined: _vm.computedGetPartner || _vm.wlBtnOutlined
                  },
                  on: { click: _vm.logout }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$vuetify.breakpoint.lgAndUp ? "Sair" : "") +
                      " "
                  ),
                  _c("v-icon", { staticClass: "mx-2", attrs: { small: "" } }, [
                    _vm._v("mdi-exit-to-app")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.dialogModalRelatorios
            ? _c("ModalRelatoriosSolicitados", {
                attrs: { dialogModalRelatorios: _vm.dialogModalRelatorios },
                on: {
                  fecharModal: function($event) {
                    _vm.dialogModalRelatorios = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.$vuetify.breakpoint.smAndDown &&
      _vm.shouldShowRow &&
      _vm.isAuthenticated
        ? _c(
            "v-row",
            {
              staticClass: "btn-troca-apresentante ma-0",
              style: _vm.computedGetPartner
                ? "background: #333E48;"
                : _vm.wlPanelColor
                ? `background: ${_vm.wlPanelColor}`
                : ""
            },
            [
              _vm.userProfile && _vm.superUsuario
                ? _c(
                    "div",
                    {
                      staticClass: "title-apresentante-m cursor-pointer",
                      attrs: { "data-cy": "alterar-apresentante" },
                      on: { click: _vm.alterarApresentante }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.userProfile.cd_apresentante) +
                          " - " +
                          _vm._s(_vm.userProfile.nm_apresentante) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.userProfile && !_vm.superUsuario
                ? _c(
                    "div",
                    { staticClass: "title-apresentante cursor-pointer" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.userProfile.cd_apresentante) +
                          " - " +
                          _vm._s(_vm.userProfile.nm_apresentante) +
                          " "
                      ),
                      _c("div", { staticClass: "title-apresentante-cnpj" }, [
                        _vm._v(
                          " " +
                            _vm._s(this.formatCnpj(_vm.userProfile.nu_cnpj)) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _c("LembreteExpiracaoSenha"),
      _c("SocialUserModalAlterarUsuario", {
        attrs: { showModal: _vm.showAlterarEmpresa },
        on: {
          fechar: function($event) {
            _vm.showAlterarEmpresa = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }